import { render, staticRenderFns } from "./CardInHome.vue?vue&type=template&id=0dfb9cd2"
import script from "./CardInHome.vue?vue&type=script&lang=ts"
export * from "./CardInHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports